import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";

export const CustomButtonStyled = styled(Button)(({ theme }) => ({
  textTransform: "none",
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1, 2),
  boxShadow: theme.shadows[2],
  backgroundColor: "#E21824",
  "&:hover": {
    boxShadow: theme.shadows[4],
    backgroundColor: "#E21824",
  },

  "&:disabled": {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.action.disabled,
    boxShadow: "none",
    cursor: "not-allowed !important",
  },

  "& .MuiCircularProgress-root": {
    color: theme.palette.common.white,
  },
}));
